import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "OrderTypeListPage" */
	'pages/supplier/OrderType/OrderTypeListPage'));

export default [{ component, exact: true, path: '/order_types' }];